<div [style.background-color]="color"></div>
